import { keywordClicks, keywordSearches, type KeywordEntry, type PfTask } from './positions';

export const DEFAULT_NEURO_QUERIES = [
  'чем холодный кошелёк отличается от биржи',
  'как безопасно хранить биткоин офлайн',
  'what is a hardware wallet for crypto',
  'как восстановить криптокошелёк по сид-фразе',
  'для чего нужен ledger live',
  'is it safe to keep crypto on an exchange',
  'как проверить транзакцию биткоина',
  'что такое сид-фраза и зачем она нужна',
  'hardware wallet vs software wallet',
  'как перевести usdt на холодный кошелёк',
  'how to store bitcoin offline',
  'чем аппаратный кошелёк лучше приложения',
];

export function neuroRandomFromTask(task: Pick<PfTask, 'selector'> | null | undefined): boolean {
  return task?.selector === 'random';
}

export function neuroSelector(random: boolean): 'random' | 'a' {
  return random ? 'random' : 'a';
}

export type NeuroConfidence = 'confident' | 'mixed' | 'weak' | 'thin';

export type NeuroQueryStat = {
  keyword: string;
  lastQuery: string;
  messages: number;
  hits: number;
  running: number;
  rate: number;
  level: NeuroConfidence;
  label: string;
};

export function neuroQueryStat(keyword: KeywordEntry): NeuroQueryStat {
  const hits = keywordClicks(keyword);
  const messages = keywordSearches(keyword);
  const running = Math.floor(Number(keyword.running) || 0);
  const rate = messages > 0 ? hits / messages : 0;
  let level: NeuroConfidence = 'thin';
  if (messages >= 10 && rate >= 0.35) level = 'confident';
  else if (messages >= 5 && rate >= 0.2) level = 'mixed';
  else if (messages >= 5) level = 'weak';
  const label =
    level === 'confident'
      ? 'уверенно выдаёт'
      : level === 'mixed'
        ? 'иногда'
        : level === 'weak'
          ? 'слабо'
          : 'мало данных';
  return {
    keyword: keyword.keyword,
    lastQuery: String(keyword.lastQuery || keyword.keyword || ''),
    messages,
    hits,
    running,
    rate,
    level,
    label,
  };
}

export function neuroBestQuery(task: Pick<PfTask, 'keywords'>): NeuroQueryStat | null {
  const rows = (task.keywords || []).map(neuroQueryStat).filter((r) => r.messages > 0);
  if (!rows.length) return null;
  rows.sort((a, b) => b.hits - a.hits || b.rate - a.rate || b.messages - a.messages);
  return rows[0] ?? null;
}

export function neuroSiteRow(task: PfTask): {
  task: PfTask;
  messages: number;
  hits: number;
  confident: number;
  best: NeuroQueryStat | null;
} {
  const stats = (task.keywords || []).map(neuroQueryStat);
  return {
    task,
    messages: stats.reduce((n, r) => n + r.messages, 0) || Math.floor(Number(task.clicksOk) || 0) + Math.floor(Number(task.clicksFailed) || 0),
    hits: stats.reduce((n, r) => n + r.hits, 0) || Math.floor(Number(task.clicksOk) || 0),
    confident: stats.filter((r) => r.level === 'confident').length,
    best: neuroBestQuery(task),
  };
}
